// src/pages/Home.jsx

import React from 'react';
import Layout from '../components/Layout'; 
import { categories, featured, services, brands } from '../data/data'; // Assuming data.js is created
import { Container, Row, Col, Card, Button,Carousel } from 'react-bootstrap';

export default function Home() {
  
  return (
    <Layout>
      
        {/* 1. Hero Section (HeroSlider equivalent) */}
     
<section className="mb-5">
  <Carousel controls={true} indicators={true} className="rounded-3 shadow-sm overflow-hidden">
    
    {/* Slide 1: Main Banner */}
    <Carousel.Item interval={4000}>
      <img
        className="d-block w-100"
        src="https://images.unsplash.com/photo-1593642532973-d31b6557fa68?auto=format&fit=crop&w=1400&q=80"
        alt="Office Solutions"
        style={{ height: '380px', objectFit: 'cover' }}
      />
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 p-5 d-flex flex-column justify-content-center">
        <h1 className="text-white fw-bold display-5">Your Partner for IT & Office Solutions</h1>
        <p className="mt-2 text-light fs-5 col-lg-6">Let us help you choose the best — with installation, configuration & AMC services.</p>
        <div className="mt-4 d-flex gap-3">
          <Button variant="primary" size="lg">Shop Now</Button>
          <Button variant="outline-light" size="lg">Explore Services</Button>
        </div>
      </div>
    </Carousel.Item>

    {/* Slide 2: Featured Products Focus */}
    <Carousel.Item interval={4000}>
      <img
        className="d-block w-100"
        src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=1400&q=80"
        alt="Featured Products"
        style={{ height: '380px', objectFit: 'cover' }}
      />
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 p-5 d-flex flex-column justify-content-center">
        <h1 className="text-white fw-bold display-5">Shop Latest IT Hardware</h1>
        <p className="mt-2 text-light fs-5 col-lg-6">Monitors, Laptops, and Peripherals at the best corporate rates.</p>
        <div className="mt-4 d-flex gap-3">
          <Button variant="primary" size="lg">Shop Hardware</Button>
          <Button variant="outline-light" size="lg">Browse Brands</Button>
        </div>
      </div>
    </Carousel.Item>
    
    {/* Slide 3: Service Focus */}
    <Carousel.Item interval={4000}>
      <img
        className="d-block w-100"
        src="https://images.unsplash.com/photo-1603791452906-bb9f30d65538?auto=format&fit=crop&w=1400&q=80"
        alt="IT Services"
        style={{ height: '380px', objectFit: 'cover' }}
      />
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 p-5 d-flex flex-column justify-content-center">
        <h1 className="text-white fw-bold display-5">End-to-End IT Support</h1>
        <p className="mt-2 text-light fs-5 col-lg-6">Network setup, CCTV installation, and annual maintenance contracts (AMC).</p>
        <div className="mt-4 d-flex gap-3">
          <Button variant="primary" size="lg">Request Quote</Button>
          <Button variant="outline-light" size="lg">Contact Support</Button>
        </div>
      </div>
    </Carousel.Item>

  </Carousel>
</section>

        {/* 2. Categories Section */}
        <section className="mb-5">
          <h2 className="fs-4 fw-semibold mb-3">Browse by Category</h2>
          <Row xs={2} sm={6} lg={7} className="g-3">
            {categories.map((c) => (
              <Col key={c.title}>
                <div className="d-flex flex-column align-items-center justify-content-center p-3 bg-white rounded shadow-sm h-100 hover-shadow">
                  <span className="fs-3 mb-2">{c.icon}</span>
                  <div className="text-center small">{c.title}</div>                       
                </div>
              </Col>
            ))}
          </Row>
        </section>

        {/* 3. Services Section */}
        <section className="mb-5 bg-info bg-opacity-10 p-5 rounded-3 shadow-sm">
          <h2 className="fs-3 fw-bold text-primary mb-4">Our IT & Office Services</h2>
          <Row xs={1} sm={2} lg={3} className="g-4">
            {services.map((s) => (
              <Col key={s.title}>
                <Card className="shadow hover-shadow h-100">
                  <Card.Img variant="top" src={s.img} style={{ height: '180px', objectFit: 'cover' }} />
                  <Card.Body>
                    <Card.Title className="text-primary fs-5">{s.title}</Card.Title>
                    <Card.Text className="text-muted small">{s.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* 4. Featured Products */}
        <section className="mb-5">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="fs-4 fw-semibold">Featured Products</h2>
            <Button variant="link" className="text-primary text-decoration-none small">View all</Button>
          </div>
          <Row xs={1} sm={2} lg={3} className="g-4">
            {featured.map((p) => (
              <Col key={p.title}>
                <Card className="h-100 shadow-sm">
                  <Card.Img variant="top" src={p.img} style={{ height: '220px', objectFit: 'cover' }} />
                  <Card.Body>
                    <Card.Title className="fs-6">{p.title}</Card.Title>
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-between align-items-center bg-white border-top-0">
                    <span className="text-primary fw-bold">{p.price}</span>
                    <Button variant="outline-secondary" size="sm">Add</Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* 5. Brands Section */}
  <section className="mb-5">
  <h2 className="fs-4 fw-semibold text-center mb-4">Brands We Deal With</h2>

  <Carousel
    controls={false}
    indicators={false}
    interval={2000} // auto-slide every 2 seconds
    pause={false} // don’t pause on hover
  >
    {Array.from({ length: Math.ceil(brands.length / 5) }).map((_, slideIndex) => (
      <Carousel.Item key={slideIndex}>
        <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap py-3">
          {brands
            .slice(slideIndex * 5, slideIndex * 5 + 5)
            .map((b) => (
              <div
                key={b.name}
                className="bg-white rounded shadow-sm p-3 d-flex align-items-center justify-content-center"
                style={{ width: "150px", height: "80px" }}
              >
                <img
                  src={b.logo}
                  alt={b.name}
                  style={{
                    maxHeight: "50px",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            ))}
        </div>
      </Carousel.Item>
    ))}
  </Carousel>
</section>


    </Layout>
  );
}